import React from 'react'
import { FiMapPin } from 'react-icons/fi'
import { MdAccessTime, MdEmail, MdLocationOn, MdPhone, MdRateReview } from 'react-icons/md'
import { clinicLocation, emailContact, mapLocation, reviewPage } from '../../../config'

function MapSection() {
  return (
    <section className='flex justify-center my-10 md:my-20 px-4 md:px-0'>
      <div className="w-full md:w-[85%] lg:w-[75%] bg-gradient-to-br from-darkBackground to-primary text-white flex flex-col md:flex-row">
        {/* Contact Details Section */}
        <div className='py-5 pb-8 md:pb-20 flex flex-col items-start'>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 mx-5 md:mx-10">Conklin Health Centre</h2>
          <div className="space-y-4 md:space-y-6 mx-5 md:mx-10">
            <a href={clinicLocation} target='_blank' className="flex items-center text-sm md:text-base">
              <MdLocationOn className="mr-2 h-5 w-5 md:h-6 md:w-6" />
              <span>360 Conklin Rd Unit A2, Brantford, ON N3T 0N5</span>
            </a>
            <a href={"tel:+1 (226) 368-1309"} className="flex items-center text-sm md:text-base">
              <MdPhone className="mr-2 h-5 w-5 md:h-6 md:w-6" />
              <span>Call +1 (226) 368-1309</span>
            </a>
            <a href={`mailto:${emailContact}`} className="flex items-center text-sm md:text-base">
              <MdEmail className="mr-2 h-5 w-5 md:h-6 md:w-6" />
              <span>info@conklinphysiochiroplus.com</span>
            </a>
            <a href={reviewPage} target='_blank' className="flex items-center text-sm md:text-base">
              <MdRateReview className="mr-2 h-5 w-5 md:h-6 md:w-6" />
              <span>Read Our Reviews</span>
            </a>
            <div className="flex items-center text-sm md:text-base">
              <MdAccessTime className="mr-2 h-5 w-5 md:h-6 md:w-6" />
              <div>
                <span>Open Hours</span>
                <div>Monday: 10AM – 7PM</div>
                <div>Tuesday: 10AM – 7PM</div>
                <div>Wednesday: 11AM – 4PM</div>
                <div>Thursday: 10AM – 7PM</div>
                <div>Friday: 10AM – 7PM</div>
                <div>Saturday: 9AM – 3PM</div>
                <div>Sunday: Closed</div>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="w-full h-64 md:h-auto overflow-hidden">
          <iframe
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            src={mapLocation}
          ></iframe>
        </div>
      </div>
    </section> 
  )
}

export default MapSection;
